import { createFileRoute } from "@tanstack/react-router";
import { SystemEventsListPage } from "../../../components/system/SystemEventsListPage";
import { requireSuperAdmin } from "../../../lib/auth/route-protection";

export const Route = createFileRoute("/system/events/")({
  beforeLoad: requireSuperAdmin(),
  component: SystemEventsRoute,
});

function SystemEventsRoute() {
  return <SystemEventsListPage />;
}
